<template>
  <div class="content">
    <h2 class="font-light">Scanned Records Index</h2>
    <server-error v-bind:error="error.serverError"></server-error>
    <div class="row">
      <search-field v-bind:search="search" @handleSearch="handleSearch">
      </search-field>
      <div class="col-4">
        <div class="form-group u-inline-flex u-pull-right">
          <filter-dropdown
            v-bind:options="filterOptions"
            v-on:handle-filter="handleFilter"
          ></filter-dropdown>
          <!-- New scanned record button -->
          <router-link
            v-if="permissions.includes('records.add_scannedrecord')"
            :to="{ name: 'scanned-record-create' }"
          >
            <button id="addButton" class="btn-info action-button">
              <span class="icon">
                <i
                  class="fa-wrapper fa fa-plus-circle normal-icon"
                  aria-hidden="true"
                ></i>
              </span>
              <span>New</span>
            </button>
          </router-link>
        </div>
      </div>
      <filter-tags v-bind:filterOptions="filterOptions"></filter-tags>
      <scanned-record-table v-bind:scannedRecordList="scannedRecordList">
      </scanned-record-table>
      <div class="row">
        <pagination-links
          v-if="pages.scannedRecordList"
          v-bind:pages="pages.scannedRecordList"
          @handlePage="handlePage"
        >
        </pagination-links>
        <page-size-selector
          v-on:handle-page-size="handlePageSize()"
        >
        </page-size-selector>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import ScannedRecordTable from "@/components/records/ScannedRecordTable";
import ServerError from "@/components/ServerError";
import SearchField from "@/components/SearchField";
import FilterDropdown from "@/components/FilterDropdown";
import FilterTags from "@/components/FilterTags";
import PaginationLinks from "@/components/Pagination";
import PageSizeSelector from "@/components/PageSizeSelector";
import { debounce } from "@/functions/debounce.function";
import { scrollToTop } from "@/functions/scrollToTop";
import { SetupFilters } from "@/services/filters.service";
import { GetSelectedFilters } from "@/services/filters.service";
import { HandleAllFilters } from "@/services/filters.service";
import { QueryHasChanged } from "@/services/filters.service";

export default {
  name: "scanned-record-index",
  components: {
    ScannedRecordTable,
    ServerError,
    FilterDropdown,
    FilterTags,
    PaginationLinks,
    PageSizeSelector,
    SearchField,
  },
  data: function() {
    return {
      search: "",
      filterOptions: {
        tags: [],
        record_type: [],
        is_active: [
          { name: "True", value: "true", selected: false },
          { name: "False", value: "false", selected: false }
        ],
      },
    }
  },
  computed: {
    ...mapGetters("records", [
      "records", "pages", "scannedRecordList",
      "scannedRecordTags", "scannedRecordTypes",
      "scannedRecordFilters",
    ]),
    ...mapGetters("core", ["results", "error"]),
    ...mapGetters("auth", ["userProfile", "permissions"]),
  },
  watch: {
    search: debounce(function() {
      let payload = { search: this.search }
      this.$store.dispatch("records/listScannedRecord", payload);
      this.$router.replace({
        name: "scanned-record-index",
        query: payload
      });
    }, 300),
    scannedRecordTags: function() {
      this.setupTagsFilter();
    },
    scannedRecordTypes: function() {
      this.setupRecordTypeFilter();
    },
  },
  methods: {
    handleSearch: function(value) {
      this.search = value;
    },
    handlePage: function(newPage) {
      if (newPage == 1) {
        newPage = "";
      }
      this.$store.commit("records/scannedRecordFilters", { page: newPage });
      this.$store.dispatch("records/listScannedRecord");
      if (QueryHasChanged(this.$route.query, this.scannedRecordFilters)) {
        this.$router.replace({
          name: "scanned-record-index",
          query: { ...this.scannedRecordFilters }
        });
      };
    },
    handlePageSize: function() {
      // Refresh the array by going to page 1 when the pageSize is changed.
      this.handlePage(1);
    },
    handleFilter: function(payload) {
      HandleAllFilters(this.scannedRecordFilters, this.filterOptions, payload);
      // Reset the page to 0 as we don't now how pages there will be
      payload.page = ""; // "" = '0'
      this.$store.commit("records/scannedRecordFilters", payload);
      this.$store.dispatch("records/listScannedRecord");
      this.$router.replace({
        name: "scanned-record-index",
        query: { ...this.scannedRecordFilters },
      });
    },
    setupTagsFilter: function() {
      // This function sets up the tags in the filterOptions Object whenever
      // the results received from the server change.
      var stack = [];
      for (let tag of this.scannedRecordTags) {
        var entry = {};
        entry["name"] = tag.label;
        entry["value"] = tag.id;
        entry["selected"] = false;
        stack.push(entry);
      }
      this.filterOptions["tags"] = stack;
    },
    setupRecordTypeFilter: function() {
      // This function sets up the tags in the filterOptions Object whenever
      // the results received from the server change.
      var stack = [];
      for (let record_type of this.scannedRecordTypes) {
        var entry = {};
        entry["name"] = record_type.label;
        entry["value"] = record_type.id;
        entry["selected"] = false;
        stack.push(entry);
      }
      this.filterOptions["record_type"] = stack;
    }
  },
  mounted() {
    // Setup filters
    SetupFilters(this, "records/scannedRecordFilters", "scanned-record-index");
    this.setupTagsFilter();
    this.setupRecordTypeFilter();
    for (let key in this.$route.query) {
      GetSelectedFilters(this.filterOptions[key], this.$route.query[key]);
    }
    // If there are *Still* no filters selected then set 'is_active' as the
    // default filter.
    if (Object.keys(this.scannedRecordFilters).length == 0) {
      this.handleFilter({ is_active: "true" });
    }
    // Initialize list of scanned records
    this.$store.dispatch("records/listScannedRecord");
    this.$store.dispatch("records/getScannedRecordTypes");
    this.$store.dispatch("records/getScannedRecordTags");
    scrollToTop();
  }
}
</script>
